// // 08-01-2026

// import React, { useEffect, useState } from "react";
// import { Plus, Search } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useNavigate } from "react-router-dom";

// import DealCard from "../components/deals/DealsCard";
// import DealFilters from "../components/deals/DealsFilter";
// import DealForm from "../components/deals/DealsForm";

// import api from "../api/api";
// import { useAuth } from "../api/authContext";

// import "../css/deals/dealspage.css";

// export default function Deals() {
//   const navigate = useNavigate();
//   const { token,isAdmin } = useAuth();

//   const [deals, setDeals] = useState([]);
//   const [leads, setLeads] = useState([]);
//   const [properties, setProperties] = useState([]);

//   const [loading, setLoading] = useState(true);
//   const [showForm, setShowForm] = useState(false);
//   const [editingDeal, setEditingDeal] = useState(null);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [filters, setFilters] = useState({ stage: "" });

//   /* ================= AUTH GUARD ================= */
//   useEffect(() => {
//     if (!token) {
//       navigate("/login");
//       return;
//     }
//     fetchAllData();
//   }, [token]);

//   /* ================= FETCH DATA ================= */
//   const fetchAllData = async () => {
//     try {
//       setLoading(true);

//       const [dealRes, leadRes, propRes] = await Promise.all([
//         api.get("/deals"),        // ownership handled in backend
//         api.get("/leads/all"),
//         api.get("/properties"),
//       ]);

//       setDeals(dealRes.data || []);
//       setLeads(leadRes.data || []);
//       setProperties(propRes.data || []);
//     } catch (error) {
//       console.error("Error loading deals data", error);

//       if (error.response?.status === 401) {
//         navigate("/login");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= CREATE / UPDATE ================= */
//   const handleSubmit = async (data) => {
//     try {
//       if (editingDeal) {
//         await api.put(`/deals/${editingDeal._id}`, data);
//       } else {
//         await api.post("/deals", data);
//       }

//       setShowForm(false);
//       setEditingDeal(null);
//       fetchAllData();
//     } catch (error) {
//       console.error("Failed to save deal", error);
//     }
//   };

//   const handleDelete = async (dealId) => {
//     if (!window.confirm("Are you sure you want to delete this deal?")) return;

//     try {
//       await api.delete(`/deals/${dealId}`);
//       fetchAllData();
//     } catch (error) {
//       console.error("Failed to delete deal", error);
//     }
//   };

//   /* ================= FILTERING ================= */
//   const filteredDeals = deals.filter((deal) => {
//     const matchesSearch =
//       deal.dealName?.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesStage =
//       !filters.stage || deal.stage === filters.stage;

//     return matchesSearch && matchesStage;
//   });

//   const totalValue = filteredDeals.reduce(
//     (sum, deal) => sum + (Number(deal.dealValue) || 0),
//     0
//   );

//   /* ================= UI ================= */
//   return (
//     <div className="deals-page">
//       <div className="deals-container">
//         {/* HEADER */}
//         <div className="deals-header">
//           <div>
//             <h1>Deal Pipeline</h1>
//             <p>Track deals from negotiation to closure</p>
//             <p className="pipeline-value">
//               Total Pipeline Value: ₹{(totalValue / 1000000).toFixed(2)}M
//             </p>
//           </div>

//           <button
//             className="add-btn"
//             onClick={() => {
//               setEditingDeal(null);
//               setShowForm(true);
//             }}
//           >
//             <Plus size={16} />
//             Create Deal
//           </button>
//         </div>

//         {/* TOOLBAR */}
//         <div className="deals-toolbar">
//           <div className="search-box">
//             <Search size={16} />
//             <input
//               placeholder="Search deals..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>

//           <DealFilters filters={filters} setFilters={setFilters} />
//         </div>

//         {/* MODAL */}
//         <AnimatePresence>
//           {showForm && (
//             <div className="modal-overlay">
//               <motion.div
//                 className="modal-content"
//                 initial={{ scale: 0.95, opacity: 0 }}
//                 animate={{ scale: 1, opacity: 1 }}
//                 exit={{ scale: 0.95, opacity: 0 }}
//               >
//                 <DealForm
//                   deal={editingDeal}
//                   leads={leads}
//                   properties={properties}
//                   onSubmit={handleSubmit}
//                   onCancel={() => {
//                     setShowForm(false);
//                     setEditingDeal(null);
//                   }}
//                   isLoading={false}
//                 />
//               </motion.div>
//             </div>
//           )}
//         </AnimatePresence>

//         {/* GRID */}
//         <div className="deals-grid">
//           {loading ? (
//             <div className="loading">Loading deals...</div>
//           ) : filteredDeals.length === 0 ? (
//             <div className="empty">No deals found</div>
//           ) : (
//             filteredDeals.map((deal, index) => (
//               <DealCard
//                 key={deal._id}
//                 deal={deal}
//                 index={index}
//                 onEdit={() => {
//                   setEditingDeal(deal);
//                   setShowForm(true);
//                 }}
//                 onDelete={() => handleDelete(deal._id)}
//                 isAdmin={isAdmin}
//               />
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
// Updated: 23-05-2026
// Changes:
// - formatINR helper: displays deal values in short Indian format
// - Total Pipeline Value in header uses formatINR
// - Reads URL query param ?stage=xxx on mount for dashboard pre-filtering
// - Added "Created By" agent filter dropdown (built from actual deal data)

import React, { useEffect, useState } from "react";
import { Plus, Search, AlertCircle, Check, X as XIcon, Clock } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

import DealCard    from "../components/deals/DealsCard";
import DealFilters from "../components/deals/DealsFilter";
import DealForm    from "../components/deals/DealsForm";
import PeriodFilterBar from "../components/common/PeriodFilterBar";

import api from "../api/api";
import { useAuth } from "../api/authContext";
import { getPeriodRange, isDateInRange } from "../utils/periodFilter";

import "../css/deals/dealspage.css";
import "../css/deals/dealApproval.css";

function formatINR(val) {
  const n = Number(val);
  if (!n || isNaN(n)) return "₹0";
  if (n >= 10_000_000) return `₹${parseFloat((n / 10_000_000).toFixed(2))} Cr`;
  if (n >= 100_000)    return `₹${parseFloat((n / 100_000).toFixed(2))} L`;
  if (n >= 1_000)      return `₹${parseFloat((n / 1_000).toFixed(1))} K`;
  return `₹${n.toLocaleString("en-IN")}`;
}

export default function Deals() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, isAdmin } = useAuth();

  const [deals,      setDeals]      = useState([]);
  const [leads,      setLeads]      = useState([]);
  const [properties, setProperties] = useState([]);

  const [loading,     setLoading]     = useState(true);
  const [showForm,    setShowForm]    = useState(false);
  const [editingDeal, setEditingDeal] = useState(null);
  const [searchTerm,  setSearchTerm]  = useState("");
  const [createdBy,   setCreatedBy]   = useState("all");
  const [period,      setPeriod]      = useState("all");
  const [weekAnchor,  setWeekAnchor]  = useState(() => new Date());
  const [customFrom,  setCustomFrom]  = useState("");
  const [customTo,    setCustomTo]    = useState("");
  const [sortBy,      setSortBy]      = useState("name");
  const [sortDir,     setSortDir]     = useState("asc");

  // ── Approval workflow state ──
  const [approvingDeal,   setApprovingDeal]   = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [approving,       setApproving]       = useState(false);
  const [showPendingOnly, setShowPendingOnly] = useState(false);

  // ── Stage update handler for real-time dashboard refresh ──
  const handleDealStageUpdate = (updatedDeal) => {
    // Update the deal in the deals array
    setDeals(prevDeals =>
      prevDeals.map(d => d._id === updatedDeal._id ? updatedDeal : d)
    );
    // Emit event to refresh dashboard analytics
    window.dispatchEvent(new CustomEvent("dealStageUpdated", { detail: updatedDeal }));
  };

  /* ── Read ?stage= from URL on mount ── */
  const initFilters = () => {
    const p = new URLSearchParams(location.search);
    return { stage: p.get("stage") || "" };
  };

  const [filters, setFilters] = useState(initFilters);

  useEffect(() => {
    setFilters(initFilters());
  }, [location.search]);

  /* ================= AUTH GUARD ================= */
  useEffect(() => {
    if (!token) { navigate("/login"); return; }
    fetchAllData();
  }, [token]);

  /* ================= FETCH DATA ================= */
  const fetchAllData = async () => {
    try {
      setLoading(true);
      const [dealRes, leadRes, propRes] = await Promise.all([
        api.get("/deals"),
        api.get("/leads/all"),
        api.get("/properties"),
      ]);
      setDeals(dealRes.data || []);
      setLeads(leadRes.data || []);
      setProperties(propRes.data || []);
    } catch (error) {
      console.error("Error loading deals data", error);
      if (error.response?.status === 401) navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  /* ================= CREATE / UPDATE ================= */
  const handleSubmit = async (data) => {
    try {
      if (editingDeal) {
        await api.put(`/deals/${editingDeal._id}`, data);
      } else {
        await api.post("/deals", data);
      }
      setShowForm(false);
      setEditingDeal(null);
      fetchAllData();
    } catch (error) {
      console.error("Failed to save deal", error);
    }
  };

  const handleDelete = async (dealId) => {
    if (!window.confirm("Are you sure you want to delete this deal?")) return;
    try {
      await api.delete(`/deals/${dealId}`);
      fetchAllData();
    } catch (error) {
      console.error("Failed to delete deal", error);
    }
  };

  /* ── Approve / Reject agent deal ── */
  const handleApprovalAction = async (action) => {
    if (!approvingDeal) return;
    setApproving(true);
    try {
      await api.patch(`/deals/${approvingDeal._id}/approve`, {
        action,
        reason: action === "reject" ? rejectionReason : undefined,
      });
      setApprovingDeal(null);
      setRejectionReason("");
      fetchAllData();
    } catch (err) {
      alert("Failed: " + (err.response?.data?.message || err.message));
    } finally {
      setApproving(false);
    }
  };

  /* ── Pending approval deals (for managers) ── */
  const pendingApprovals = deals.filter(
    (d) => d.stage === "approval" && d.approvalStatus === "pending"
  );

  /* ── Build unique agent list from actual data ── */
  const agentOptions = [...new Set(
    deals.map((d) => d.createdByEmail).filter(Boolean)
  )].sort();

  /* ================= FILTERING ================= */
  const periodRange = getPeriodRange(period, { weekAnchor, customFrom, customTo });

  const filteredDeals = deals.filter((deal) => {
    const matchesSearch  = deal.dealName?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStage   = !filters.stage || deal.stage === filters.stage;
    const matchesAgent   = createdBy === "all" || deal.createdByEmail === createdBy;
    const matchesPending = !showPendingOnly || (deal.stage === "approval" && deal.approvalStatus === "pending");
    const matchesPeriod  = isDateInRange(deal.createdDate, periodRange);
    return matchesSearch && matchesStage && matchesAgent && matchesPending && matchesPeriod;
  }).sort((a, b) => {
    if (sortBy === "createdDate") {
      const diff = new Date(a.createdDate || 0) - new Date(b.createdDate || 0);
      return sortDir === "asc" ? diff : -diff;
    }
    if (sortBy === "dealValue") {
      const diff = (Number(a.dealValue) || 0) - (Number(b.dealValue) || 0);
      return sortDir === "asc" ? diff : -diff;
    }
    const cmp = (a.dealName || "").localeCompare(b.dealName || "");
    return sortDir === "asc" ? cmp : -cmp;
  });

  const totalValue = filteredDeals.reduce(
    (sum, deal) => sum + (Number(deal.dealValue) || 0), 0
  );

  /* ================= UI ================= */
  return (
    <div className="deals-page">
      <div className="deals-container">

        {/* HEADER */}
        <div className="deals-header">
          <div>
            <h1>Deal Track  </h1>
            <p>Track deals from negotiation to closure</p>
            <p className="pipeline-value">
              Total  Value: {formatINR(totalValue)}
            </p>
          </div>
          <button
            className="add-btn"
            onClick={() => { setEditingDeal(null); setShowForm(true); }}
          >
            <Plus size={16} /> Create Deal
          </button>
        </div>

        {/* ── PENDING APPROVALS BANNER (Managers only) ── */}
        {isAdmin && pendingApprovals.length > 0 && (
          <div className="pending-approvals-banner">
            <div className="pending-banner-icon">
              <AlertCircle size={22} />
            </div>
            <div className="pending-banner-text">
              <h3>{pendingApprovals.length} Pending Deal Approval{pendingApprovals.length > 1 ? "s" : ""}</h3>
              <p>Agent deal conversion requests awaiting your review</p>
            </div>
            <button
              className="pending-banner-btn"
              onClick={() => setShowPendingOnly(v => !v)}
            >
              {showPendingOnly ? "Show All Deals" : `Review ${pendingApprovals.length} Request${pendingApprovals.length > 1 ? "s" : ""}`}
            </button>
          </div>
        )}

        <PeriodFilterBar
          period={period} onPeriodChange={setPeriod}
          weekAnchor={weekAnchor} onWeekAnchorChange={setWeekAnchor}
          customFrom={customFrom} onCustomFromChange={setCustomFrom}
          customTo={customTo} onCustomToChange={setCustomTo}
          sortBy={sortBy} onSortByChange={setSortBy}
          sortDir={sortDir} onSortDirChange={setSortDir}
          sortOptions={[
            { value: "name",        label: "Deal Name" },
            { value: "createdDate", label: "Created Date" },
            { value: "dealValue",   label: "Deal Value" },
          ]}
        />

        {/* TOOLBAR */}
        <div className="deals-toolbar">
          <div className="search-box">
            <Search size={16} />
            <input
              placeholder="Search deals..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <DealFilters filters={filters} setFilters={setFilters} />

          {/* Created By filter */}
          <select
            className="deal-filter-select"
            value={createdBy}
            onChange={(e) => setCreatedBy(e.target.value)}
          >
            <option value="all">All Agents</option>
            {agentOptions.map((email) => (
              <option key={email} value={email}>{email}</option>
            ))}
          </select>
        </div>

        {/* MODAL */}
        <AnimatePresence>
          {showForm && (
            <div className="modal-overlay">
              <motion.div
                className="modal-content"
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.95, opacity: 0 }}
              >
                <DealForm
                  deal={editingDeal}
                  leads={leads}
                  properties={properties}
                  onSubmit={handleSubmit}
                  onCancel={() => { setShowForm(false); setEditingDeal(null); }}
                  isLoading={false}
                />
              </motion.div>
            </div>
          )}
        </AnimatePresence>

        {/* GRID */}
        <div className="deals-grid">
          {loading ? (
            <div className="loading">Loading deals...</div>
          ) : filteredDeals.length === 0 ? (
            <div className="empty">No deals found</div>
          ) : (
            filteredDeals.map((deal, index) => (
              <DealCard
                key={deal._id}
                deal={deal}
                index={index}
                onEdit={() => { setEditingDeal(deal); setShowForm(true); }}
                onDelete={() => handleDelete(deal._id)}
                onApprove={
                  isAdmin && deal.stage === "approval" && deal.approvalStatus === "pending"
                    ? () => setApprovingDeal(deal)
                    : null
                }
                onStageUpdate={handleDealStageUpdate}
                isAdmin={isAdmin}
              />
            ))
          )}
        </div>

        {/* ── DEAL APPROVAL MODAL ── */}
        {approvingDeal && (
          <div className="modal-overlay" onClick={() => setApprovingDeal(null)}>
            <div className="approval-modal" onClick={(e) => e.stopPropagation()}>
              <div className="approval-modal-header">
                <div className="approval-icon">
                  <Clock size={20} />
                </div>
                <div style={{ flex: 1 }}>
                  <h3>Review Deal Conversion Request</h3>
                  <p>
                    <strong>{approvingDeal.createdByEmail || "Agent"}</strong> is requesting to convert a lead to a deal
                  </p>
                </div>
                <button className="approval-close-btn" onClick={() => setApprovingDeal(null)}>
                  <XIcon size={18} />
                </button>
              </div>

              <div className="approval-modal-body">
                <div className="approval-section">
                  <h4>Deal Details</h4>
                  <div className="approval-grid">
                    <div className="approval-row"><span>Deal Name</span><strong>{approvingDeal.dealName}</strong></div>
                    <div className="approval-row"><span>Deal Value</span><strong>{formatINR(approvingDeal.dealValue)}</strong></div>
                    <div className="approval-row"><span>Commission</span><strong>{formatINR(approvingDeal.commissionAmout)}</strong></div>
                    <div className="approval-row"><span>Win Probability</span><strong>{approvingDeal.winProbability || 0}%</strong></div>
                    {approvingDeal.expectedCloseDate && (
                      <div className="approval-row">
                        <span>Expected Close</span>
                        <strong>{new Date(approvingDeal.expectedCloseDate).toLocaleDateString("en-IN")}</strong>
                      </div>
                    )}
                  </div>
                </div>

                {approvingDeal.leadID && (
                  <div className="approval-section">
                    <h4>Lead Information</h4>
                    <div className="approval-grid">
                      <div className="approval-row"><span>Lead Name</span><strong>{approvingDeal.leadID?.full_name || "—"}</strong></div>
                      <div className="approval-row"><span>Phone</span><strong>{approvingDeal.leadID?.phone || "—"}</strong></div>
                      <div className="approval-row"><span>Interest</span><strong>{approvingDeal.leadID?.interest_level || "—"}</strong></div>
                    </div>
                  </div>
                )}

                {approvingDeal.propertyID && (
                  <div className="approval-section">
                    <h4>Linked Property</h4>
                    <div className="approval-grid">
                      <div className="approval-row"><span>Property</span><strong>{approvingDeal.propertyID?.propertyName || "—"}</strong></div>
                      <div className="approval-row"><span>Location</span><strong>{approvingDeal.propertyID?.location || "—"}</strong></div>
                      <div className="approval-row"><span>Price</span><strong>{formatINR(approvingDeal.propertyID?.price)}</strong></div>
                    </div>
                  </div>
                )}

                {approvingDeal.notes && (
                  <div className="approval-section">
                    <h4>Agent Notes</h4>
                    <p className="approval-notes">{approvingDeal.notes}</p>
                  </div>
                )}

                <div className="approval-section">
                  <label htmlFor="rejReason">Rejection reason (optional, shown if you reject)</label>
                  <textarea
                    id="rejReason"
                    className="approval-reason-input"
                    placeholder="Explain why this deal is being rejected…"
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    rows={3}
                  />
                </div>
              </div>

              <div className="approval-modal-footer">
                <button
                  className="approval-btn-reject"
                  disabled={approving}
                  onClick={() => handleApprovalAction("reject")}
                >
                  <XIcon size={14} /> {approving ? "Rejecting…" : "Reject"}
                </button>
                <button
                  className="approval-btn-approve"
                  disabled={approving}
                  onClick={() => handleApprovalAction("approve")}
                >
                  <Check size={14} /> {approving ? "Approving…" : "Approve"}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}